import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {
    StyledAgendaSidebarCard,
    StyledAgendaSidebarCardTitle
} from '@/features/agenda/components/agenda-sidebar-card/style'

export const AgendaSidebarCardLoader = ({title}: {title?: string}) => {
    return (
        <StyledAgendaSidebarCard direction="column" gap={2.5} fullWidth>
            <Flexbox justify="space-between" align="center" fullWidth>
                <StyledAgendaSidebarCardTitle role="button">
                    {title ? title : <Skeleton width={100} height={20} />}
                </StyledAgendaSidebarCardTitle>
            </Flexbox>
            <Flexbox direction="column" gap={1} fullWidth>
                {Array.from({length: 3}).map((_, index) => (
                    <Skeleton key={index} width={`calc(100% - ${index * 40}px)`} height={20} />
                ))}
            </Flexbox>
        </StyledAgendaSidebarCard>
    )
}
